export default "__VITE_ASSET__615451a2__"